import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store";
Vue.config.productionTip = false;
import "./assets/iconfont/iconfont.css";
import "./assets/iconfont/iconfont.js";
import Vant from "vant";
import "vant/lib/index.css";
import "./utils/dsbridge";
import http from "./http/index";

Vue.prototype.$http = http;
Vue.use(Vant);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
